import axios from "./axios";
import config from "../config";
import qs from 'qs'

function login(params) {
    return axios({
        url: config.backendUrl + 'api/auth/login',
        method: 'POST',
        data: params
    })
}
function userInfo(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/info',
        method: 'GET',
        params: params
    })
}

function getUserRoleMenu(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/getUserRoleMenu',
        method: 'GET',
        params: params
    })
}

function searchUserList(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/searchList',
        method: 'GET',
        params: params
    })
}

function addUser(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/add',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function updateUser(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/update',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function resetPwd(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/reset-pwd',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function checkUsername(id, name) {
    return axios({
        url: config.backendUrl + 'api/system/user/check-username',
        method: 'GET',
        params: {
            id,
            name
        }
    })
}

function checkPhone(id, phone) {
    return axios({
        url: config.backendUrl + 'api/system/user/check-phone',
        method: 'GET',
        params: {
            id,
            phone
        }
    })
}

function updateGroups(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/update-group',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function getGroupTree(type) {
    return axios({
        url: config.backendUrl + 'api/system/org/list-tree',
        method: 'GET',
        params: {
            type
        }
    })
}
function saveUserGroup(params) {
    return axios({
        url: config.backendUrl + 'api/system/org/save',
        method: 'POST',
        data: params
    })
}

function deleteSysOrgById(id) {
    return axios({
        url: config.backendUrl + 'api/system/org/del/'+id,
        method: 'delete',
    })
}

function getRoles(id) {
    return axios({
        url: config.backendUrl + 'api/system/user/get-role',
        method: 'GET',
        params: {
            id
        }
    })
}

function updateRoles(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/update-role',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function enableUser(params) {
    return axios({
        url: config.backendUrl + 'api/system/user/enable',
        method: 'POST',
        data: qs.stringify(params, {arrayFormat: 'repeat'})
    })
}

function deleteUser(id) {
    return axios({
        url: config.backendUrl + 'api/system/user/delete',
        method: 'POST',
        data: qs.stringify({
            id
        }, {arrayFormat: 'repeat'})
    })
}


export default {
    login,
    userInfo,
    getUserRoleMenu,
    searchUserList,
    addUser,
    updateUser,
    updateGroups,
    enableUser,
    deleteUser,
    resetPwd,
    checkUsername,
    checkPhone,
    getGroupTree,
    saveUserGroup,
    deleteSysOrgById,
    getRoles,
    updateRoles
}
